<template>
  <nav class="fm-breadcrumb">
    <button class="fm-bc-item fm-bc-home" @click="$emit('navigate', [null])">
      <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd"/></svg>
      Mi unidad
    </button>
    <template v-for="(segment, idx) in pathSegments">
      <svg :key="'sep-' + idx" class="fm-bc-sep" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd"/>
      </svg>
      <button
        :key="'seg-' + idx"
        :class="['fm-bc-item', { current: idx === pathSegments.length - 1 }]"
        @click="navigate(idx)"
      >{{ segment.name }}</button>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'FMBreadcrumb',
  props: { path: Array },
  inject: ['getFileById'],
  computed: {
    pathSegments() {
      return this.path.slice(1).map(id => ({
        id,
        name: this.getFileById(id)?.name || id
      }))
    }
  },
  methods: {
    navigate(idx) {
      const newPath = [null, ...this.path.slice(1, idx + 2)]
      this.$emit('navigate', newPath)
    }
  }
}
</script>

<style scoped>
.fm-breadcrumb {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  flex-shrink: 0;
  gap: 2px;
  border-bottom: 1px solid var(--fm-border);
  background: var(--fm-surface);
}
.fm-bc-item {
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  color: var(--fm-text2);
  font-family: var(--fm-font);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 3px 7px;
  border-radius: var(--fm-radius-sm);
  transition: background 0.12s, color 0.12s;
  white-space: nowrap;
}
.fm-bc-item:hover { background: var(--fm-surface3); color: var(--fm-text); }
.fm-bc-item.current { color: var(--fm-text); cursor: default; }
.fm-bc-item.current:hover { background: none; }
.fm-bc-home svg { width: 13px; height: 13px; }
.fm-bc-sep { width: 14px; height: 14px; color: var(--fm-text2); flex-shrink: 0; }
</style>
